import { getField, updateField } from 'vuex-map-fields';
import { types } from './mutation-types';

interface IContactPersonState {
  isAgreementsChecked: boolean;
  name: string;
  surname: string;
  email: string;
  isOtherEmailChecked: boolean;
  otherEmail: string;
  phoneNumber: string;
  answer: string;
}

function getDefaultState(): IContactPersonState {
  return {
    isAgreementsChecked: false,
    name: '',
    surname: '',
    email: '',
    isOtherEmailChecked: false,
    otherEmail: '',
    phoneNumber: '',
    answer: '',
  };
}

export const contactPerson = {
  /*
   * namespace provide better map options
   * e.g:
   * without namespaced:
   * ...mapState({
   *   someProperty => state.moduleName.someState
   *   anotherProperty => state.moduleName.anotherProperty
   * })
   * with namespaced:
   * ...mapState('moduleName', ['someProperty','anotherProperty'])
   * using dispatch: this.$store.dispatch('moduleName/actionName', ...)
   * */
  namespaced: true,
  state: getDefaultState(),
  /*
   * yourGetter(state) { return state.yourState }
   * */
  getters: {
    getField,
  },
  /**
   * Mutations update the state
   * Mutations MUST BE SYNC
   * */
  mutations: {
    updateField,
    /*
     * Add product to state
     * @param {object} state - current state
     * @param {object} product - product object to insert to state
     */
    [types.CHANGE_AGREEMENTS](state, payload) {
      state.isAgreementsChecked = payload;
    },
    [types.SET_NAME](state, name) {
      state.name = name;
    },
    [types.SET_SURNAME](state, surname) {
      state.surname = surname;
    },
    [types.SET_EMAIL](state, email) {
      state.email = email;
    },
    [types.CHANGE_OTHER_EMAIL](state, isChecked) {
      state.isOtherEmailChecked = isChecked;
    },
    [types.SET_OTHER_EMAIL](state, otherEmail) {
      state.otherEmail = otherEmail;
    },
    [types.SET_PHONE_NUMBER](state: IContactPersonState, phoneNumber) {
      state.phoneNumber = phoneNumber;
    },
    [types.SET_USER_ANSWER](state: IContactPersonState, userAnswer) {
      state.answer = userAnswer;
    },
    [types.HYDRATE](state: IContactPersonState, payload: Partial<IContactPersonState> = {}) {
      Object.assign(state, getDefaultState(), payload);
    },
  },
  /*
   * Actions commit mutations
   * This is place to get data from API
   * */
  actions: {
    /*
     * @param {context}
     * @param {payload}
     * */
    handleAgreementsChecked({ commit }, isChecked) {
      commit(types.CHANGE_AGREEMENTS, isChecked);
    },
    handleNameChange({ commit }, newName) {
      commit(types.SET_NAME, newName);
    },
    handleSurnameChange({ commit }, newSurname) {
      commit(types.SET_SURNAME, newSurname);
    },
    handleEmailChange({ commit }, newEmail) {
      commit(types.SET_EMAIL, newEmail);
    },
    handleOtherEmailChange({ commit }, newOtherEmail) {
      commit(types.SET_OTHER_EMAIL, newOtherEmail);
    },
    handleOtherMailChecked({ commit }, isChecked) {
      commit(types.CHANGE_OTHER_EMAIL, isChecked);
    },
    handlePhoneNumberChange({ commit }, newPhoneNumber) {
      commit(types.SET_PHONE_NUMBER, newPhoneNumber);
    },
    handelUserAnswerChange({ commit }, newUserAsnwer) {
      commit(types.SET_USER_ANSWER, newUserAsnwer);
    },
    hydrate({ commit }, state: Partial<IContactPersonState>) {
      commit(types.HYDRATE, state);
    },
  },
};
